import React, {useEffect, useState} from "react";
import {createFactor, getFactorItems} from "./crud/factorCrud";
import {domain} from "../../../_metronic/_helpers/GlobalConsts";
import {Image} from "react-bootstrap";
import moment from "jalali-moment";
import Workbook from "react-excel-workbook";
import ExcelExport from "./Exports/ExcelExport";


export default function FactorForm(
    {
        match: {
            params: {id},
        },
    }
){

    // const [factor_date, setFactor_date] = useState([]);
    // let [status, setStatus] = useState([]);
    // const [description, setDescription] = useState([]);
    const [singleFactor, setSingleFactor] = useState([]);

    const fetchData = () => {
        getFactorItems(id)
            .then((response) => {
                setSingleFactor(response.data.data);
            });
    };

    useEffect(() => {
        fetchData()
    }, []);

    function handleExportDate(e) {
        e.preventDefault();
        return(
            <>
                <div className="row text-center" style={{marginTop: '100px'}}>
                    <Workbook filename='test.xlsx'>
                        <Workbook.Sheet data={setSingleFactor.orders} name="sheet">
                            <Workbook.Column label="id" value={row => row.id}/>
                            <Workbook.Column label="price" value="test"/>
                        </Workbook.Sheet>
                    </Workbook>
                </div>
            </>
        )
    }

    const createRequests = () => {
        // console.log(data);
    };

    // const worksheets = [
    //     {
    //         name: "Requests",
    //         columns: [
    //             { label: "Full Name", value: "name" },
    //             { label: "Email", value: "email" },
    //             { label: "Template", value: "template" }
    //         ],
    //         data: [
    //             {
    //                 name: "Bob Ross",
    //                 email: "boss_ross@gmail.com",
    //                 template: "Accounts Receivables"
    //             }
    //         ]
    //     }
    // ];

    // function saveFactor(){
    //     if(status == ""){
    //         status="pending";
    //     }
    //     const formData = new FormData();
    //     formData.append('factor_date', factor_date);
    //     formData.append('status', status);
    //     formData.append('description',description);
    //     createFactor(formData)
    //         .then(() => {
    //
    //         })
    // }


    return (
        <>
            <div className="wall">
                <div className="table-responsive">
                    <table className="table table-striped gy-7 gs-7">
                        <thead>
                        <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                            <th className="min-w-200px">شناسه</th>
                            <th className="min-w-400px">تصویر</th>
                            <th className="min-w-100px">قیمت لیر</th>
                            <th className="min-w-200px">تاریخ</th>
                            <th className="min-w-200px">وضعیت</th>
                            <th className="min-w-200px">قیمت تومان</th>
                        </tr>
                        </thead>
                        <tbody>
                        { singleFactor.orders &&  singleFactor.orders.map( (item,key) =>

                            <tr>
                                <td>{item.id}</td>
                                <td>
                                    <Image thumbnail src={item.product.images[0] && domain + item.product.images[0].url}
                                        style={{height: '150px', width: 'auto'}} />
                                </td>
                                <td>{item.price} TL</td>
                                <td>{item.created_at}</td>
                                <td>{item.status.name}</td>
                                <td>---</td>
                            </tr>
                        )}


                        <hr/>
                        {singleFactor &&
                            <tr>
                                    <td>تعداد محصولات</td>
                                    <td>{singleFactor.number_of_products}</td>
                                    <td>مبلغ کل ( لیر )</td>
                                    <td>{singleFactor.total_price_lir} TL</td>
                                    <td>تاریخ فاکتور</td>
                                    <td>
                                        {/*{moment(new Date(singleFactor.factor_date*1000),'YYYY-M-D').format('jYYYY/jMM/jDD ')+' - ' + new Date(singleFactor.factor_date * 1000).toLocaleDateString("en-US")}*/}
                                    </td>
                            </tr>
                        }


                        </tbody>
                    </table>
                </div>
                <ExcelExport filename={id + '-factor.xlsx'} orders={(singleFactor) && singleFactor.orders}  />
            </div>

        </>

    )

}